export interface CarburateGlobalSettings {
  // Static fallback exchange rate. This should be replaced with a backend-provided value.
  defaultExchangeRate: string;
  // Whether to enable payments and all related UI elements (buttons, banners, etc.).
  enablePayments: boolean;
  // Whether to enable the reset walkthrough. This should only be used for testing purposes.
  enableAdminPannel: boolean;
}

export const global_settings = {
  defaultExchangeRate: "1.16",
  enablePayments: false,
  enableAdminPannel: false,
  enableBetaUIElements: true,
};
